import {IProductListFilterItem, ProductListFilterItem} from "./ProductListFilterItem";
import {IAvailableFilter, IFilterValue} from "../items/interface/Item.interface";

export class ProductListFilterItemSelect extends ProductListFilterItem implements IProductListFilterItem {
  public rootValues: Map<string, IFilterValue>;

  protected _value: string[];

  public constructor(filterItemData: IAvailableFilter) {
    super(filterItemData);

    this.rootValues = this.values;

    this._value = this.getValueFromResult(filterItemData);
  }

  public get value(): string[] {
    return this._value;
  }

  public set value(value: string[]) {
    this._value = value.filter((item) => {
      return this.rootValues.has(item);
    });
  }

  public get paramValue(): string {
    return this.value.join(",");
  }

  public clear() {
    this._value = [];
  }

  public getValueFromResult(filterItemData: IAvailableFilter): string[] {
    if (filterItemData.values.length !== this.rootValues.size) {
      return filterItemData.values.map((value) => value.id);
    }

    return [];
  }

  public applyFilterItemResult(filterItem: IAvailableFilter): void {
    this._value = this.getValueFromResult(filterItem);
  }
}
